import {Component, Input} from '@angular/core';

@Component({
  selector: 'field-date-readonly',
  templateUrl: 'field-date-readonly.component.html',
  styleUrls: ['field-date-readonly.component.scss']
})
export class FieldDateReadonlyComponent {
  @Input() field: any;

  constructor() {
  }

  ngOnInit() {
  }

  get value() {
    return this.field.value?.data || [];
  }

}
